import { createTheme } from '@mui/material';

type InputStyles = {
  mainColor?: string; // background and border
  contrastTextColor?: string;
};

export const createThemeByCompanyStyles = ({
  mainColor = '#FFDB00',
  contrastTextColor = '#011627',
}: InputStyles) => {
  return createTheme({
    palette: {
      primary: {
        main: mainColor,
        contrastText: contrastTextColor,
      },
      secondary: {
        main: '#383838',
        contrastText: '#ffffff',
      },
      action: {
        active: mainColor,
        hover: '#F0F0F1',
        disabled: '#ffffff',
        disabledBackground: mainColor,
      },
      text: {
        primary: '#011627',
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: (themeParam) => `
      :root {
        --main-color: ${themeParam.palette.text.primary};
        --company-main-background: ${themeParam.palette.primary.main};
        --company-main-border: ${themeParam.palette.primary.main};
        --company-main-color-contrast-text: ${themeParam.palette.primary.contrastText};
        --main-color-contrast: #ffffff;
        --warning-color: #FFA011;
        --input-label-color: #ACB3B8;
      }
        * {
          color: ${themeParam.palette.text.primary};
        }
        h6, h5, h4, h3, h2, h1 {
          color: ${themeParam.palette.text.primary};
        }
        input {
          display: block;
          min-height: 38px;
      
          width: 100%;
          resize: none;
      
          padding: 10px 11px 9px;
          color: var(--main-color);
          font-weight: 400;
          font-size: 14px;
          line-height: 16px;
      
          background: none;
      
          border: 1px solid #D0D3D6;
          border-radius: 5px;
        }
        input::placeholder {
          color: #ACB3B8;
        }
        a[href] {
          font-weight: 400;
          font-size: 14px;
          line-height: 16px;
          text-decoration-line: underline;
          color: #ACB3B8;
        }
        h3 {
          font-family: 'GT America', sans-serif;
          font-weight: 900;
          font-size: 36px;
          line-height: 99%;
        }
      `,
      },
    },
  });
};
